import api from './api';

// A trace id fans out to every subscribed integration, so callers that know the
// integration pass its id to get that integration's execution, not the first match.
const fetchStepFunctionExecutionsByTraceId = async (traceId, integrationId) => {
  try {
    // Values are encoded by hand instead of using axios `params`: axios encodes the
    // brackets in the filter keys, which breaks the Cypress intercepts on this URL.
    const encodedTraceId = encodeURIComponent(traceId);
    let url = `/log-inspector?filter[x_decisiv_trace_id_eq]=${encodedTraceId}`;
    if (integrationId) {
      const encodedIntegrationId = encodeURIComponent(integrationId);
      url += `&filter[integration_uuid_eq]=${encodedIntegrationId}`;
    }

    const { data } = await api.get(url);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const fetchStepFunctionExecutionsByParentTraceId = async (traceId) => {
  try {
    const { data } = await api.get(
      `/log-inspector?filter[parent_x_decisiv_trace_id_eq]=${traceId}`,
    );

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const fetchStepFunctionExecutionsByIntegrationId = async ({
  integrationId,
  page = 1,
  limit = 25,
  source = null,
  triggerType = null,
  status = null,
  startDate = null,
  stopDate = null,
} = {}) => {
  try {
    const requestParams = {
      'filter[with_source]': source,
      'filter[with_trigger_type]': triggerType,
      'filter[with_status]': status,
      'filter[start_date_gteq]': startDate,
      'filter[stop_date_lteq]': stopDate,
      'page[number]': page,
      'page[size]': limit,
    };

    // Remove keys with null values
    const filteredRequestParams = Object.fromEntries(
      Object.entries(requestParams).filter(([_key, value]) => value !== null),
    );

    const { data } = await api.get(
      `/log-inspector?filter[integration_uuid_eq]=${integrationId}`,
      {
        params: filteredRequestParams,
      },
    );

    return { data: data.data, totalRecords: data.meta.total_records };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const fetchStepFunctionExecutionById = async (id) => {
  try {
    const { data } = await api.get(`/log-inspector/${id}`);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const fetchStepFunctionExecutionsByConfiguredIntegrationId = async (
  configuredIntegrationId,
  page = 1,
  limit = 25,
) => {
  try {
    const { data } = await api.get(
      `/log-inspector?filter[configured_integration_uuid_eq]=${configuredIntegrationId}`,
      {
        params: {
          'page[number]': page,
          'page[size]': limit,
        },
      },
    );

    return { data: data.data, totalRecords: data.meta.total_records };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default {
  fetchStepFunctionExecutionsByTraceId,
  fetchStepFunctionExecutionsByParentTraceId,
  fetchStepFunctionExecutionById,
  fetchStepFunctionExecutionsByIntegrationId,
  fetchStepFunctionExecutionsByConfiguredIntegrationId,
};
